import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import SearchBox from './containers/SearchBox'
import { PAGE_HOTELS_LIST } from '../../constants'
import { isDesktop } from '../../helpers/browser'
import store from '../shared/store'

// const searchResults = document.querySelector('.search-results')
// const firstStep = document.querySelector('.first-step')
// const secondStep = document.querySelector('.second-step')

// if (!searchResults && !firstStep && !secondStep) require('../shared/store')
/**
 *
 * @param searchBoxData<Object> - window.drupalSettings.widgets.searchBox
 * @param filtersData<Object>   - window.drupalSettings.widgets.filters
 * @param filtersTypes<Array>   - possible values ['dates', 'rooms', 'more', 'code']
 * @param activeFilter<String>  - defines the opened by default filter if is set.
 *                                Possible: 'dates', rooms', 'more', 'sort'
 * @param pageIndex<Number>     - The index of current HTML page
 * @returns {*}
 */
const searchBox = (
  searchBoxData,
  filtersData,
  filtersTypes,
  activeFilter,
  pageIndex = PAGE_HOTELS_LIST,
) => {
  const containerID = (document.getElementById('search-box-mobile') && !isDesktop()) ? 'search-box-mobile' : 'search-box'
  const root = createRoot(document.getElementById(containerID))

  root.render(
    <StrictMode>
      <Provider store={store}>
        <SearchBox
          searchBoxData={searchBoxData}
          filtersData={filtersData}
          filtersTypes={filtersTypes}
          activeFilter={activeFilter}
          pageIndex={pageIndex}
        />
      </Provider>
    </StrictMode>
  )
}

export default searchBox
